export default __webpack_public_path__ + "static/media/roteador.e3ff4cf4.png";